import { Component, OnInit } from '@angular/core';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { Activity, ActivityCategory, ActivityStatus } from '../../model/activity';

import * as XLSX from 'xlsx';
type AOA = any[][];

import { Bidding, BiddingStatus } from '../../model/bidding';
import { BrCurrencyPipe } from '../../pipes/br-currency-pipe';
import { DatePipe } from '../../../../node_modules/@angular/common';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '../../../../node_modules/@angular/router';

declare var $: any;

@Component({
  selector: 'app-excel-report',
  templateUrl: './excel-report.component.html',
  styleUrls: ['./excel-report.component.css'],
  providers: [DBService, DatePipe, BrCurrencyPipe, AuthenticationService]
})
export class ExcelReportComponent implements OnInit {

  data: AOA;

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  initialDate: number;
  initialDateString: string;

  endDate: number;
  endDateString: string;

  companyFilter: string;

  companies: Company[];
  displayBiddings: Bidding[];
  biddings: Bidding[];

  loading: boolean;

  emptyData: boolean;

  isAdminUser: boolean;

  isWin: boolean;

  label: string;

  constructor(private router: Router, private dbService: DBService, private datePipe: DatePipe, private currencyPipe: BrCurrencyPipe, private authService: AuthenticationService) {
    this.isAdminUser = this.authService.isAdmin();
    this.initialDateString = '';
    this.endDateString = '';
    this.companyFilter = '0';
    this.emptyData = true;

    this.isWin = this.router.url.includes('relatorios-licitacoes-vencidas');
    this.label = this.isWin ? 'Vencidas' : 'Perdidas';

    this.loadCompanies();
    this.loadBiddings();
  }

  private prepareExcelDataWin() {
    this.data = [ ['Cliente', 'Órgão Comprador', 'Data do Pregão', 'Valor (R$)']];
    this.displayBiddings.forEach(item => {
      item['companyName'] = this.getCompany(item.companyUID);

      this.data.push(
        [
          item['companyName'],
          item.purchasingOrgan,
          this.datePipe.transform(item.biddingDate, 'dd/MM/yyyy'),
          this.currencyPipe.transform(item.earningPrice)
        ]
      );
    });
  }

  private getCompany(uid) {
    const tempCompanies = this.companies.filter(company => company.uid === uid);
    return tempCompanies.length > 0 ? tempCompanies[0].name : '';
  }

  private prepareExcelDataLost() {
    this.data = [ ['Cliente', 'Órgão Comprador', 'Data do Pregão', 'Empresa Vencedora', 'Valor Final (R$)']];
    this.displayBiddings.forEach(item => {
      item['companyName'] = this.getCompany(item.companyUID);

      this.data.push(
        [
          item['companyName'],
          item.purchasingOrgan,
          this.datePipe.transform(item.biddingDate, 'dd/MM/yyyy'),
          item.lostCompetitor,
          this.currencyPipe.transform(item.lostPrice)
        ]
      );
    });
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        this.companies = companies;
        if (!this.isAdminUser) {
          this.companyFilter = this.authService.getUserCompany();
        }
      });
  }

  private loadBiddings() {
    this.dbService.listWithUIDs<Bidding>('biddings')
      .then(biddings => this.biddings = biddings);
  }

  search() {
    this.emptyData = false;

    this.displayBiddings = this.biddings
      .filter(a => a.creationDate >= this.initialDate)
      .filter(a => a.creationDate <= this.endDate);

    if (this.companyFilter != '' && this.companyFilter != '0') {
      this.displayBiddings = this.displayBiddings.filter(a => a.companyUID == this.companyFilter);
    }

    this.initData();
  }

  private initData() {
    this.loading = true;

    this.isWin = this.router.url.includes('relatorios-licitacoes-vencidas');
    if (this.isWin) {
      this.displayBiddings = this.displayBiddings.filter(b => b.status == BiddingStatus.EARNED);
      this.prepareExcelDataWin();
    } else {
      this.displayBiddings = this.displayBiddings.filter(b => b.status == BiddingStatus.LOST);
      this.prepareExcelDataLost();
    }

    this.loading = false;
  }

  ngOnInit() {
    $( function() {
      $( ".datePicker" ).datepicker({
        dateFormat: 'dd/mm/yy',
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        nextText: 'Proximo',
        prevText: 'Anterior'
      });
    } );
  }


  async delay(ms: number) {
      await new Promise(resolve => setTimeout(()=>resolve(), ms));
  }

  onChangeStartDate(event) {

    this.delay(1000).then(any => {
    
      this.initialDateString = event.target.value;
      const dateParts = this.initialDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.initialDate;
      } else {
        this.initialDate = date.getTime();
      }

    });

  }

  onChangeEndDate(event) {

    this.delay(1000).then(any => { 

      this.endDateString = event.target.value;
      const dateParts = this.endDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.endDate;
      } else {
        this.endDate = date.getTime();
      }

    });
  }
    

  exportExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, `Relatório de Licitações ${this.label}.xlsx`);
  }
}

export class ActivityReportItem {
  icon: string;
  title: string;
  total: number;
  done: number;
  pending: number;
  problem: number;
}


// WEBPACK FOOTER //
// ./src/app/pages/excel-report/excel-report.component.ts